import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { TOASTER_STATE } from '../../../Model/Enums';
import { useUpdateEntrepreneurMutation } from '../../../Store/entrepreneur';
import { useCreateCompanyMutation, useUpdateCompanyMutation } from '../../../Store/company';
import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { currentCompanySelector } from '../../../Store/paramsBagSlice';
import { userSelector } from '../../../Store/authSlice';
import { SubmitHandler, UseFormRegister } from 'react-hook-form';
import { Entrepreneur } from '../../../Model/Entrepreneur';

export const useEntrepreneurForm = (
  isUpdate: boolean,
  register: UseFormRegister<Partial<Entrepreneur> & { taxNumber: string; companyName: string }>,
  reset: () => void
) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelector);
  const currentCompany = useAppSelector(currentCompanySelector);

  const [updateEntrepreneur, { isLoading: entrLoading }] = useUpdateEntrepreneurMutation();
  const [createCompany, { isLoading: companyLoading }] = useCreateCompanyMutation();
  const [updateCompany, { isLoading: updateCompanyLoading }] = useUpdateCompanyMutation();

  const onSubmit: SubmitHandler<Partial<Entrepreneur> & { taxNumber: string; companyName: string }> = async (data) => {
    const { taxNumber, companyName, name, mobile } = data;

    try {
      await updateEntrepreneur({ name: name, mobile: mobile ?? user.mobile }).unwrap();
    } catch (e) {
      dispatch(changeToasterState(TOASTER_STATE.ENTREPRENEUR_CREATION_FAILED));
      dispatch(toggleModal());
    }

    if (isUpdate) {
      try {
        await updateCompany({
          _id: currentCompany?._id,
          taxNumber: taxNumber ?? currentCompany.taxNumber,
          name: companyName,
        }).unwrap();
        dispatch(changeToasterState(TOASTER_STATE.ENTREPRENEUR_SAVE_OR_EDIT_SUCCESS));
        reset();
      } catch (e) {
        dispatch(changeToasterState(TOASTER_STATE.COMPANY_CREATION_FAILED));
      }
    } else {
      try {
        await createCompany({ taxNumber: taxNumber, name: companyName }).unwrap();
        dispatch(changeToasterState(TOASTER_STATE.ENTREPRENEUR_SAVE_OR_EDIT_SUCCESS));
        reset();
      } catch (e) {
        dispatch(changeToasterState(TOASTER_STATE.COMPANY_CREATION_FAILED));
      }
    }

    dispatch(toggleModal());
  };

  const onClose = () => {
    dispatch(toggleModal());
  };
  return {
    onSubmit,
    onClose,
    inProgress: entrLoading || companyLoading || updateCompanyLoading,
    user,
    currentCompany,
  };
};
